import React from "react";
import { Outlet } from "react-router-dom";
import { DashboardLayout } from "@/components/layouts/DashboardLayout";
import { LayoutProvider } from "@/contexts/LayoutContext";

const StudentLayout = () => {
  return (
    <LayoutProvider>
      <DashboardLayout>
        <Outlet />
      </DashboardLayout>
    </LayoutProvider>
  );
};

export default StudentLayout;